









































import { Component, Prop, Vue } from 'vue-property-decorator';
import Customer from '@/models/Customer';
import CustomerService from '@/services/CustomerService';

@Component
export default class CompanyEdit extends Vue {
    @Prop() public id!: number;

    private Model: Customer = new Customer();
    private PageTitle: string = '';
    private Validated: boolean = false;

    private async created() {
        this.PageTitle = `${this.id === 0 ? 'New' : 'Edit'} Company`;
        if (this.id > 0) {
            this.LoadCustomer(this.id);
        }
    }

    private PropertyState(propertyName: string) {
        if (!this.Validated) {
            return null;
        } else {
            const statusObj = this.Model.PropertyState(propertyName);
            if (statusObj) {
                return statusObj.Status;
            } else {
                return null;
            }
        }
    }

    private PropertyMessage(propertyName: string) {
        if (!this.Validated) {
            return '';
        } else {
            const statusObj = this.Model.PropertyState(propertyName);
            if (statusObj) {
                return statusObj.Message;
            } else {
                return null;
            }
        }
    }

    private async LoadCustomer(id: number) {
        const customerService = new CustomerService();
        const response = await customerService.LoadCustomer(id);
        if (response.Error === true) {
            this.$bvModal.msgBoxOk(`There was an error while trying to load the information`);
        } else {
            if (response.Data != null) {
                this.Model = response.Data;
            }
        }
    }

    private async SaveForm() {
        const customerService = new CustomerService();

        let response: any;
        if (this.id === 0) {
            response = await customerService.AddCustomer(this.Model);
        } else {
            response = await customerService.UpdateCustomer(this.Model);
        }

        if (response.Error === true) {
            this.$bvModal.msgBoxOk(`There was an error while trying to save the information`);
        } else {
            this.$emit('changessaved', this.id > 0);
            this.$emit('editcancelled');
        }
    }

    private CancelSave() {
        this.$emit('editcancelled');
    }
}
